import React, { useEffect } from 'react';

import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Pill from 'shared/atoms/Pill';
import T from 'shared/atoms/Typography';

import theme from 'shared/themes/default';

import EpisodesSeenGraph from './EpisodesSeenGraph';
import TableWithSearchAndExport from './TableWithSearchAndExport';
import UsersWatchDataTable from './UsersWatchDataTable';

import { useWatchData } from '../Context';
import { listAggregatedWatchData } from '../Context/graphql/queries';

const Wrapper = styled.div`
  max-width: 100%;
`;

const WrapperPill = styled.div`
  display: flex;
  margin-top: 108px;
  ${theme.breakpoints.mobile} {
    margin-top: 64px;
  }
`;

const ShowUsersData = () => {
  const { t } = useTranslation();
  const {
    fetchUsersWatchData,
    isBackOffice,
    loadingUsersWatchData,
    organizationSelectedId,
    restClient,
    setWatchDataError,
    useLazyGraphQLQuery,
    usersWatchData,
  } = useWatchData();

  const [listAggregatedWatchDataQuery, listAggregatedWatchDataResponse] =
    useLazyGraphQLQuery(listAggregatedWatchData);

  const aggregatedWatchData =
    listAggregatedWatchDataResponse.data?.listAggregatedWatchData || [];

  useEffect(() => {
    fetchUsersWatchData({
      variables: {
        organizationId: organizationSelectedId,
      },
    });
    listAggregatedWatchDataQuery({
      variables: {
        filter: {
          organizationId: organizationSelectedId,
        },
      },
    });
  }, [organizationSelectedId]);

  useEffect(() => {
    const { error } = listAggregatedWatchDataResponse;

    if (error) {
      setWatchDataError(true);
    }
  }, [listAggregatedWatchDataResponse]);

  return (
    <Wrapper>
      <WrapperPill>
        <Pill
          color={theme.palette.lightPure}
          fontColor={theme.palette.mainDark}
        >
          {t('watchData.titleUsers').toUpperCase()}
        </Pill>
      </WrapperPill>
      <T
        color={theme.palette.brand}
        fontWeight="medium"
        phoneVariant="headingXs"
        sx={{
          marginBottom: theme.spacing.m3,
          marginTop: theme.spacing.m2,
        }}
        variant="headingS"
      >
        {isBackOffice
          ? t('watchData.titleAllUsersOrganization')
          : t('watchData.titleAllUsers')}
      </T>
      <EpisodesSeenGraph
        data={aggregatedWatchData}
        loading={listAggregatedWatchDataResponse.loading}
      />
      <TableWithSearchAndExport
        itemsToDisplay={usersWatchData || []}
        downloadItems={() =>
          restClient.get(`/watchData/organizations/${organizationSelectedId}`)
        }
        tableTitle={t('watchData.activityOfYourUsers')}
        searchPlaceHolder={t('watchData.searchForUsers')}
        TableToDisplay={UsersWatchDataTable}
        showRowsAreClickableMessage
        loading={loadingUsersWatchData}
        spinnerDuration={150}
        emptyMessage={t('watchData.noActivity')}
        tableProps={{
          organizationSelectedId,
        }}
      />
    </Wrapper>
  );
};

export default ShowUsersData;
